<template>
  <div>
    <link rel="stylesheet" href="css/transporation.css"/>
    <div>
      <HeaderOfPage :bgSrc="'banner-partner.jpeg'" :theDiscription="'شركاؤنا'" :titleOfPage="'شركاؤنا'"/>
    </div>
    <section class="pages-container">
      <b-container>
        <b-row>
          <b-col sm="3" cols="6" v-for="d in 8" :key="d">
            <SingleTransportCard/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div  class="pagination">
              <b-pagination
                :total-rows="5"
                :per-page="1"
                first-number
                last-number
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script type="text/javascript">
import HeaderOfPage from '../global/HeaderOfPage'
import SingleTransportCard from '../transportation/SingleTransportCard'
  export default {
    name:'Partners',
    components: {
      HeaderOfPage,
      SingleTransportCard
    }
  }
</script>
